import { LyfeAvatar } from "@lyfegen-platform/react-common";
import { Box, Link, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { toggleMenu } from "../../store/layout";
import { userPersonalInfoState } from "../../store/user";
import layoutStyles from "./layout-styles";
import Menu from "./Menu";
import Modules from "./Modules";
import LyfegenLogo from "../../components/icons/LyfegenLogo";

export type BaseModule = { name: string; link: string; key: string; icon?: JSX.Element };

export type Module = {
	main: BaseModule;
	subModules: Array<BaseModule & { link: string }>;
};

interface IProps {
	modules: Array<Module>;
	handleLogout: () => void;
	identityServerUrl: string;
}

const NavBar: React.FC<IProps> = ({ modules, handleLogout, identityServerUrl }) => {
	const { bold, mr3 } = layoutStyles();
	const userData = useRecoilValue(userPersonalInfoState);
	const setOpen = useSetRecoilState(toggleMenu);
	const { t } = useTranslation();

	const handleClick = () => {
		setOpen((prevState) => !prevState);
	};

	return (
		<Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
			<Box display="flex">
				<Box display="flex" alignItems="center" style={{ fontSize: "2em", color: "red" }}>
					<LyfegenLogo />
				</Box>
				<Modules modules={modules} />
			</Box>
			<Box display="flex" alignItems="center">
				{!userData.exposedResource ? (
					<>
						<Typography className={`${bold} ${mr3}`} color="textPrimary" style={{ maxWidth: "170px", wordWrap: "break-word" }}>
							{userData.organization?.name}
						</Typography>
						<LyfeAvatar
							onClick={handleClick}
							lastName={userData.lastName || ""}
							firstName={userData.firstName || ""}
							src={userData.userImg || ""}
						/>

						<Menu identityServerUrl={identityServerUrl} handleLogout={handleLogout} />
					</>
				) : (
					<Box textAlign="right">
						<Typography color="textSecondary" style={{ fontWeight: 300 }}>
							{t("document-was-shared-by")}
						</Typography>
						<Typography color="textSecondary" style={{ fontWeight: 400 }}>
							{userData.exposedResource?.creatorName} &lt;
							<Link href={userData.exposedResource?.creatorEmail} underline="none">
								{userData.exposedResource?.creatorEmail}
							</Link>
							&gt; {t("at")} {userData.exposedResource?.creatorOrganizationName}
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};

export default NavBar;
